"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function renderIsotope(value) {
    return value.replaceAll(/(?<isotope>\d+)/g, '<sup>$<isotope></sup>');
}
function IsotopesViewer({ value = '', ...othersProps }) {
    return ((0, jsx_runtime_1.jsx)("div", { ...othersProps, 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: renderIsotope(value),
        } }));
}
exports.default = IsotopesViewer;
